import Swiper from "swiper";
import { Navigation, Zoom } from "swiper/modules";

const MD_BREAKPOINT = 744;
const LG_BREAKPOINT = 1280;

export default function initProjectCarousel() {
  const projectSwiperWrappers = document.querySelectorAll(
    ".project-swiper-wrapper"
  );

  if (!projectSwiperWrappers.length) return;

  projectSwiperWrappers.forEach((wrapper) => {
    const swiperContainer = wrapper.querySelector(".project-swiper");
    const prevButton = wrapper.querySelector(
      ".project-swiper .swiper-button-prev"
    );
    const nextButton = wrapper.querySelector(
      ".project-swiper .swiper-button-next"
    );
    const toggler = wrapper.querySelector(".project-toggler");
    const togglerCount = toggler?.querySelector("span");
    // Support modal inside wrapper OR external modal via data-modal-target
    const modalTarget = toggler?.dataset.modalTarget;
    const modal = modalTarget
      ? document.querySelector(modalTarget)
      : wrapper.querySelector(".project-modal");

    if (!swiperContainer) return;

    // Update toggler count based on photo count
    const slides = swiperContainer.querySelectorAll(".swiper-slide");
    const totalSlides = slides.length;

    if (toggler && togglerCount) {
      if (totalSlides <= 1) {
        // 1 photo: icon only, hide count
        togglerCount.style.display = "none";
      } else if (totalSlides <= 6) {
        // 2-6 photos: show count without plus
        togglerCount.textContent = totalSlides;
      } else {
        // 7+: show "6+"
        togglerCount.textContent = "6+";
      }
    }

    let desktopSwiper = null;
    let modalSwiper = null;

    function initDesktopSwiper() {
      if (desktopSwiper) return;

      desktopSwiper = new Swiper(swiperContainer, {
        modules: [Navigation],
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton,
        },
      });
    }

    function destroyDesktopSwiper() {
      if (desktopSwiper) {
        desktopSwiper.destroy(true, true);
        desktopSwiper = null;
      }
    }

    function handleResize() {
      if (window.innerWidth >= LG_BREAKPOINT) {
        initDesktopSwiper();
      } else {
        destroyDesktopSwiper();
      }
    }

    handleResize();
    window.addEventListener("resize", handleResize);

    if (toggler && modal) {
      const modalSwiperContainer = modal.querySelector(".project-modal-swiper");
      const modalPrevButton = modal.querySelector(".carousel-button-prev");
      const modalNextButton = modal.querySelector(".carousel-button-next");
      const progressBar = modal.querySelector(".carousel-progress-bar");
      const modalControls = modal.querySelector(".carousel-controls");
      const closeButton = modal.querySelector(".modal-close");

      function updateProgressBar(swiper) {
        if (!swiper || !progressBar) return;

        const total = swiper.slides.length;
        const currentIndex = swiper.realIndex + 1;
        const progress = (currentIndex / total) * 100;
        progressBar.style.width = `${progress}%`;
      }

      function updateControlsVisibility(swiper) {
        if (!modalControls) return;
        if (swiper.slides.length <= 1) {
          modalControls.style.display = "none";
        } else {
          modalControls.style.display = "";
        }
      }

      function openModal() {
        const scrollbarWidth =
          window.innerWidth - document.documentElement.clientWidth;

        document.body.classList.add("modal-open");
        document.body.style.overflow = "hidden";

        if (scrollbarWidth > 0) {
          document.body.style.paddingRight = `${scrollbarWidth}px`;
        }

        modal.style.display = "flex";
        setTimeout(() => {
          modal.classList.add("show");
        }, 10);

        if (!modalSwiper && modalSwiperContainer) {
          const isMobile = window.innerWidth < MD_BREAKPOINT;

          // Wrap .project-image in swiper-zoom-container that fills the slide
          if (isMobile) {
            modalSwiperContainer
              .querySelectorAll(".swiper-slide .project-image")
              .forEach((projectImage) => {
                const zoomDiv = document.createElement("div");
                zoomDiv.classList.add("swiper-zoom-container");
                projectImage.parentNode.insertBefore(zoomDiv, projectImage);
                zoomDiv.appendChild(projectImage);
              });
          }

          modalSwiper = new Swiper(modalSwiperContainer, {
            modules: [Navigation, Zoom],
            slidesPerView: 1,
            spaceBetween: 24,
            loop: true,
            navigation: {
              prevEl: modalPrevButton,
              nextEl: modalNextButton,
            },
            zoom: isMobile ? { maxRatio: 3 } : false,
            on: {
              init: function () {
                updateProgressBar(this);
                updateControlsVisibility(this);
              },
              slideChange: updateProgressBar,
            },
          });
        }
      }

      function closeModal() {
        modal.classList.remove("show");

        setTimeout(() => {
          modal.style.display = "none";
          document.body.classList.remove("modal-open");
          document.body.style.overflow = "";
          document.body.style.paddingRight = "";
        }, 150);
      }

      function handleKeydown(e) {
        if (e.key === "Escape" && modal.classList.contains("show")) {
          closeModal();
        }
      }

      toggler.addEventListener("click", openModal);

      if (closeButton) {
        closeButton.addEventListener("click", closeModal);
      }

      modal.addEventListener("click", (e) => {
        if (e.target === modal) {
          closeModal();
        }
      });

      document.addEventListener("keydown", handleKeydown);
    }
  });
}
